import { parseBoolean } from '@amazon/vinyl-util'
import { queryParam } from '@/util/queryParams'

// When `?disableApq=true` (or `?disableApq=1`) is in the querystring the
// gql layer skips Automatic Persisted Queries entirely and sends the full
// query string on every request. Useful when a Firefly hash
// collision / mismatch is masking the underlying GraphQL error; without
// APQ the gateway returns the actual error instead of
// `PersistedQueryNotFound`. Read once at module load to mirror
// `core/noCache.ts`; the toggle navigates (full reload) so a live read is
// unnecessary.
export const apqDisabled = parseBoolean(queryParam('disableApq'))
